/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1AuthUpdatePayloadLocation } from './V1AuthUpdatePayloadLocation'
import {
    V1AuthUpdatePayloadLocationFromJSON,
    V1AuthUpdatePayloadLocationFromJSONTyped,
    V1AuthUpdatePayloadLocationToJSON,
    V1AuthUpdatePayloadLocationToJSONTyped
} from './V1AuthUpdatePayloadLocation'

/**
 * Profile fields to change; absent fields keep their value.
 * @export
 * @interface V1AuthUpdatePayload
 */
export interface V1AuthUpdatePayload {
    /**
     *
     */
    tocConcent?: number
    /**
     *
     */
    ppConcent?: number
    /**
     *
     */
    login?: string
    /**
     *
     */
    bio?: string
    /**
     *
     */
    goal?: string
    /**
     *
     */
    age?: string
    /**
     *
     */
    language?: string
    /**
     * IANA timezone of the device (marketing quiet hours)
     */
    timezone?: string
    /**
     *
     */
    leaderboardHidden?: boolean
    /**
     *
     */
    location?: V1AuthUpdatePayloadLocation
}

/**
 * Check if a given object implements the V1AuthUpdatePayload interface.
 */
export function instanceOfV1AuthUpdatePayload(
    value: object
): value is V1AuthUpdatePayload {
    return true
}

export function V1AuthUpdatePayloadFromJSON(json: any): V1AuthUpdatePayload {
    return V1AuthUpdatePayloadFromJSONTyped(json, false)
}

export function V1AuthUpdatePayloadFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1AuthUpdatePayload {
    if (json == null) {
        return json
    }
    return {
        tocConcent:
            json['toc_concent'] == null ? undefined : json['toc_concent'],
        ppConcent: json['pp_concent'] == null ? undefined : json['pp_concent'],
        login: json['login'] == null ? undefined : json['login'],
        bio: json['bio'] == null ? undefined : json['bio'],
        goal: json['goal'] == null ? undefined : json['goal'],
        age: json['age'] == null ? undefined : json['age'],
        language: json['language'] == null ? undefined : json['language'],
        timezone: json['timezone'] == null ? undefined : json['timezone'],
        leaderboardHidden:
            json['leaderboardHidden'] == null
                ? undefined
                : json['leaderboardHidden'],
        location:
            json['location'] == null
                ? undefined
                : V1AuthUpdatePayloadLocationFromJSON(json['location'])
    }
}

export function V1AuthUpdatePayloadToJSON(json: any): V1AuthUpdatePayload {
    return V1AuthUpdatePayloadToJSONTyped(json, false)
}

export function V1AuthUpdatePayloadToJSONTyped(
    value?: V1AuthUpdatePayload | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        toc_concent: value['tocConcent'],
        pp_concent: value['ppConcent'],
        login: value['login'],
        bio: value['bio'],
        goal: value['goal'],
        age: value['age'],
        language: value['language'],
        timezone: value['timezone'],
        leaderboardHidden: value['leaderboardHidden'],
        location: V1AuthUpdatePayloadLocationToJSON(value['location'])
    }
}
